export default __webpack_public_path__ + "static/media/card-identity-type-old.e173305a.png";